import { createMuiTheme } from '@material-ui/core/styles';

/**
 * Канон админки (MUI v4): зелёный как в mobile `configs/colors.js`.
 * Спека: docs/product/2026-08-24-admin-visual-refresh.md
 */
export const ADMIN_PRIMARY = '#0E935F';
export const ADMIN_PRIMARY_DARK = '#0c7a4f';
export const ADMIN_PRIMARY_LIGHT = '#21BC8C';
export const ADMIN_FIELD_FILL = '#F8FAFC';
export const ADMIN_FIELD_BORDER = '#CBD5E1';
export const ADMIN_HAIRLINE = '#E2E8F0';
export const ADMIN_FOCUS_RING = 'rgba(14, 147, 95, 0.18)';

const adminTheme = createMuiTheme({
  palette: {
    primary: {
      main: ADMIN_PRIMARY,
      dark: ADMIN_PRIMARY_DARK,
      light: ADMIN_PRIMARY_LIGHT,
      contrastText: '#ffffff',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    divider: ADMIN_HAIRLINE,
    text: {
      primary: '#1E293B',
      secondary: '#64748B',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    h4: {
      fontSize: '1.125rem',
      fontWeight: 700,
      lineHeight: 1.35,
    },
    h5: {
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '0.9375rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    subtitle1: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.45,
    },
    subtitle2: {
      fontSize: '0.8125rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.8125rem',
      lineHeight: 1.45,
    },
    caption: {
      fontSize: '0.75rem',
      lineHeight: 1.4,
    },
    button: {
      fontSize: '0.8125rem',
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 12,
  },
  overrides: {
    MuiPaper: {
      rounded: {
        borderRadius: 12,
      },
      elevation1: {
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
      },
      elevation2: {
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
        borderRadius: 8,
        fontWeight: 600,
        minHeight: 40,
      },
      contained: {
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        '&:hover': {
          boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
        },
      },
      outlined: {
        borderRadius: 8,
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 8,
        backgroundColor: ADMIN_FIELD_FILL,
        '& $notchedOutline': {
          borderColor: ADMIN_FIELD_BORDER,
        },
        '&:hover $notchedOutline': {
          borderColor: ADMIN_PRIMARY,
        },
        '&$focused $notchedOutline': {
          borderColor: ADMIN_PRIMARY,
          borderWidth: 1,
        },
        '&$focused': {
          boxShadow: `0 0 0 2px ${ADMIN_FOCUS_RING}`,
        },
      },
    },
    MuiCheckbox: {
      colorPrimary: {
        '&$checked': {
          color: ADMIN_PRIMARY,
        },
      },
    },
    MuiTabs: {
      indicator: {
        height: 3,
        borderRadius: '3px 3px 0 0',
        backgroundColor: ADMIN_PRIMARY,
      },
    },
    MuiTab: {
      root: {
        textTransform: 'none',
        fontWeight: 500,
        minHeight: 44,
        fontSize: '0.875rem',
      },
      textColorPrimary: {
        '&$selected': {
          fontWeight: 600,
        },
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: 12,
      },
    },
    MuiListItemText: {
      primary: {
        fontSize: '0.875rem',
      },
      secondary: {
        fontSize: '0.8125rem',
      },
    },
    MuiTableCell: {
      root: {
        fontSize: '0.875rem',
      },
      head: {
        fontSize: '0.8125rem',
        fontWeight: 600,
      },
    },
    MuiInputLabel: {
      root: {
        fontSize: '0.875rem',
      },
    },
    MuiFormLabel: {
      root: {
        fontSize: '0.875rem',
      },
    },
  },
});

export default adminTheme;
